import { React, useEffect, useState } from 'react';
import { Breadcrumb, Layout, Menu, Image, Row, Col, Button, DatePicker, Progress, Card, Input, Tag, Typography, Space } from 'antd';
import { EditOutlined, HeartOutlined, PlusOutlined } from '@ant-design/icons';
import { Pie, measureTextWidth, Line } from '@ant-design/plots';
import { ProList } from '@ant-design/pro-components';
const { RangePicker } = DatePicker;
const { Search } = Input;
const TuitionFeeHome = () => {
    const [data, seData] = useState([{
        title: '语雀的天空',
        avatar:
            'https://gw.alipayobjects.com/zos/antfincdn/efFD%24IOql2/weixintupian_20170331104822.jpg',
    },
    {
        title: 'Ant Design',
        avatar:
            'https://gw.alipayobjects.com/zos/antfincdn/efFD%24IOql2/weixintupian_20170331104822.jpg',
    },
    {
        title: '蚂蚁金服体验科技',
        avatar:
            'https://gw.alipayobjects.com/zos/antfincdn/efFD%24IOql2/weixintupian_20170331104822.jpg',
    },
    {
        title: 'TechUI',
        avatar:
            'https://gw.alipayobjects.com/zos/antfincdn/efFD%24IOql2/weixintupian_20170331104822.jpg',
    },]);
    const [click_button, set_click_button] = useState(null);
    const [buuton_item, set_button_item] = useState([{ tag_id: null, tag_name: '全部' }, { tag_id: 1, tag_name: '尚未付款' }, { tag_id: 2, tag_name: '退費' }])
    const [click_button1, set_click_button1] = useState(null);
    const [buuton_item1, set_button_item1] = useState([{ tag_id: null, tag_name: '全部' }, { tag_id: 1, tag_name: '兒童美語班' }])
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const changeTag = (tag_id) => {
        // setData([]);
        set_click_button(tag_id);
        // setitemdatacheck(true);
        // setpage(1);
        // get_data(tag_id, 1);
        // get_folder(tag_id);
        // get_all_data(tag_id);
    }
    const changeTag1 = (tag_id) => {
        // setData([]);
        set_click_button1(tag_id);
        // setitemdatacheck(true);
        // setpage(1);
        // get_data(tag_id, 1);
        // get_folder(tag_id);
        // get_all_data(tag_id);
    }
    return (
        <Row gutter={[8, 8]} style={{ paddingTop: '10px' }}>
            <Col span={24}>
                <Card bordered>
                    <Row gutter={[8, 16]}>
                        <Col style={{ fontSize: '32px', fontWeight: 700 }} span={24}>學費詳情</Col>
                        <Col span={24}>
                            <Row gutter={[16, 8]}>
                                {buuton_item && buuton_item.map((items, i) => {
                                    if (click_button == items.tag_id) {
                                        console.log(items)
                                        return (
                                            <Col>
                                                <Button style={{ borderRadius: '15px', width: '100%', backgroundColor: '#EC00BC', color: '#FFFFFF', paddingLeft: '20px', paddingRight: '20px' }}
                                                    onClick={e => {
                                                        changeTag(items.tag_id)
                                                    }}>{items.tag_name}</Button>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col>
                                                <Button style={{ borderRadius: '15px', width: '100%', color: '#EC00BC', paddingLeft: '20px', paddingRight: '20px' }} onClick={e => {
                                                    changeTag(items.tag_id)
                                                }}>{items.tag_name}</Button>
                                            </Col>
                                        )
                                    }
                                })}
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[16, 8]}>
                                {buuton_item1 && buuton_item1.map((item, i) => {
                                    if (click_button1 == item.tag_id) {
                                        return (
                                            <Col>
                                                <Button style={{ borderRadius: '15px', width: '100%', backgroundColor: '#B100B7', color: '#FFFFFF', paddingLeft: '20px', paddingRight: '20px' }}
                                                    onClick={e => {
                                                        changeTag1(item.tag_id)
                                                    }}>{item.tag_name}</Button>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col>
                                                <Button style={{ borderRadius: '15px', width: '100%', color: '#B100B7', paddingLeft: '20px', paddingRight: '20px' }} onClick={e => {
                                                    changeTag1(item.tag_id)
                                                }}>{item.tag_name}</Button>
                                            </Col>
                                        )
                                    }
                                })}
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col>學費期間</Col>
                                <Col><RangePicker /></Col>
                                <Col><Search /></Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <ProList
                                rowKey="title"
                                expandable={{ expandedRowKeys, onExpandedRowsChange: setExpandedRowKeys }}
                                dataSource={data}
                                metas={{
                                    subTitle: {
                                        render: () => {
                                            return (
                                                <>
                                                    <Row gutter={16} style={{ width: '110%' }}>
                                                        <Col span={4}>
                                                            <Row>
                                                                <Col span={24}>繳費編號:1234567</Col>
                                                                <Col span={24} style={{ color: 'gray' }}>美語衝刺班（月繳）</Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={4}>
                                                            <Row>
                                                                <Col span={24}>姓名：</Col>
                                                                <Col span={24}>王美麗（Rich）</Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={4}>
                                                            <Row>
                                                                <Col span={24}>1件</Col>
                                                                <Col span={24} style={{ color: 'red' }}>NT$15000</Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={4}>
                                                            <Row>
                                                                <Col span={24}>建立日期</Col>
                                                                <Col span={24}>2023-06-25</Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Row gutter={12}>
                                                                <Col span={16}>
                                                                    <Progress percent={80} />
                                                                </Col>
                                                                <Col span={8} style={{ color: 'gray' }}>連載中</Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </>
                                            );
                                        },
                                    },
                                    description: {
                                        render: () => {
                                            return (
                                                <>
                                                    <Row gutter={16}>
                                                        <Col span={11}>
                                                            <Card bordered>
                                                                <div style={{ fontSize: '28px', fontWeight: 700 }}>學費詳情</div>
                                                                <DemoPie />
                                                            </Card>
                                                        </Col>
                                                        <Col span={11}>
                                                            <Card bordered>
                                                                <DemoLine />
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )
                                        },
                                    },
                                    extra: {
                                        render: () => {
                                            return <div style={{ color: 'blue', paddingRight: '5px' }}>編輯</div>;
                                        },
                                    },
                                }}
                            />
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row >
    )
}
export default TuitionFeeHome;

const DemoPie = () => {
    function renderStatistic(containerWidth, text, style) {
        const { width: textWidth, height: textHeight } = measureTextWidth(text, style);
        const R = containerWidth / 2; // r^2 = (w / 2)^2 + (h - offsetY)^2

        let scale = 1;

        if (containerWidth < textWidth) {
            scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
        }

        const textStyleStr = `width:${containerWidth}px;`;
        return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`;
    }

    const data = [
        {
            type: '分类一',
            value: 27,
        },
        {
            type: '分类二',
            value: 25,
        },
    ];
    const config = {
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.6,
        label: {
            type: 'inner',
            offset: '-50%',
            content: '{value}',
            style: {
                textAlign: 'center',
                fontSize: 14,
            },
        },
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
        ],
        statistic: {
            title: false,
            content: {
                style: {
                    whiteSpace: 'pre-wrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
            },
        },
    };
    return <Pie {...config} />;
};
const DemoLine = () => {
    const [data, setData] = useState([{
        "Date": "2010-01",
        "scales": '上課'
    },
    {
        "Date": "2010-02",
        "scales": '上課'
    },
    {
        "Date": "2010-04",
        "scales": '未上課'
    },
    {
        "Date": "2010-05",
        "scales": '上課'
    },]);

    const config = {
        data,
        padding: 'auto',
        xField: 'Date',
        yField: 'scales',
        label: {},
        point: {
            size: 5,
            shape: 'diamond',
            style: {
                fill: 'white',
                stroke: '#5B8FF9',
                lineWidth: 2,
            },
        },
        tooltip: {
            showMarkers: false,
        },
        state: {
            active: {
                style: {
                    shadowBlur: 4,
                    stroke: '#000',
                    fill: 'red',
                },
            },
        },
        interactions: [
            {
                type: 'marker-active',
            },
        ],
    };

    return <Line {...config} />;
};
